import api from "./api";

/**
 * GET /business/branches/{branch}/reviews — newest first. Read-only: a business
 * cannot reply to, hide or delete a review; hiding is the admin's.
 *
 * `filters.staffId` and `filters.rating` narrow the list; `meta.rating` and
 * `meta.providers` always describe the whole branch (hidden reviews excluded).
 */
export const fetchBranchReviews = async (branchId, { page = 1, staffId, rating } = {}) => {
  const { data } = await api.get(`/business/branches/${branchId}/reviews`, {
    params: {
      page,
      ...(staffId ? { staff_id: staffId } : {}),
      ...(rating ? { rating } : {}),
    },
  });
  return { reviews: data.data.reviews, meta: data.meta };
};
